import React from 'react';
import replaceCharacters from '../../helpers';

export const AmountRequest = {
    Header: () => 'Monto',
    id: 'monto_solicitado',
    Cell: ({ row }) => {
        return (
            <span>
                {replaceCharacters(
                    'cast_amount',
                    row.original.monto_solicitado
                )}
            </span>
        );
    },
};
